(function (Fandango, initialRoutes) {
  'use strict';

  var RegExes = {
    SPACE: /\s/g,
    UNSAFE_CHARS: /[^a-z0-9\s]/gi,
  };

  var Errors = {
    DUPLICATE_ROUTE: 'Route with name "%s" exists'
  };

  var linkFunctions = {};
  var linkTokens = {};

  function toValue(opts, value) {
    if (value === null || typeof value === 'undefined') {
      return '';
    }

    var results = value.toString();
    if (!opts) {
      return results;
    }

    if (opts.lowercase) {
      results = results.toLowerCase();
    }

    if (opts.encode) {
      results = encodeURIComponent(results);
    }

    if (opts.strip) {
      results = results.replace(RegExes.UNSAFE_CHARS, '');
    }

    if (typeof opts.replaceSpaces === 'undefined' || typeof opts.replaceSpaces === 'string') {
      results = results.replace(RegExes.SPACE, opts.replaceSpaces || '-');
    }

    return results;
  }

  function qsStringify(params) {
    if (!params || typeof params !== 'object') {
      return '';
    }

    var values = [];
    for (var key in params) {
      if (hasOwnProperty.call(params, key)) {
        values.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
      }
    }

    if (!values.length) {
      return '';
    }

    return values.join('&');
  }

  function addQueryParams(url, params) {
    if (typeof url !== 'string') {
      return url;
    }

    var str = qsStringify(params);
    if (!str) {
      return url;
    }

    return url + (url.indexOf('?') < 0 ? '?' : '&') + str;
  }

  function getLink(name, params, queryParams) {
    var linkInfo = linkTokens[name];

    if (!linkInfo || !linkInfo.tokens) {
      return '';
    }

    if (!params) {
      return addQueryParams(linkInfo.path || '', queryParams);
    }

    var results = '';

    linkInfo.tokens.forEach(function (data) {
      if (data.literal) {
        results += data.literal || '';
        return;
      }

      var opts = params[data.key];
      if (typeof opts === 'undefined' || opts === null) {
        results += ':' + data.key;
      } else {
        results += toValue(opts, typeof opts === 'object' ? opts.value : opts) || (':' + data.key);
      }
    });

    results = addQueryParams(results, queryParams);
    return results;
    // return results.replace(RegExes.SPACE, '-');
  }

  function register(linkInfo, name) {
    if (linkTokens[name]) {
      throw new Error(Errors.DUPLICATE_ROUTE.replace('%s', name));
    }

    linkTokens[name] = {
      path: linkInfo.path,
      tokens: linkInfo.tokens || linkInfo.pathTokens
    };

    linkFunctions[name] = function (params, queryParams) {
      return getLink(name, params, queryParams);
    };
  }

  function importRegistry(linkRegistry) {
    for (var name in linkRegistry) {
      register(linkRegistry[name], name);
    }
    return linkFunctions;
  }

  Fandango.link = Object.assign({
    __testable__: {
      register: register,
    },
  }, importRegistry(initialRoutes || {}));
})(window.Fandango || {}, window.Fandango && window.Fandango.context && window.Fandango.context._routes);
